import { isContainerType } from "./vod-title";
export const VOD_WIZARD_STEPS = [
    "identity",
    "master",
    "subtitles",
    "description",
    "artwork",
    "rights",
    "packages",
];
const blank = (value) => !value || value.trim() === "";
function textIsComplete(entry) {
    return (!blank(entry.language) &&
        !blank(entry.title) &&
        !blank(entry.synopsisShort) &&
        !blank(entry.synopsisMedium) &&
        !blank(entry.synopsisLong));
}
export function wizardSteps(state) {
    var _a, _b, _c, _d;
    const texts = (_a = state.localizedInfo) !== null && _a !== void 0 ? _a : [];
    const done = (step) => ({
        step,
        state: "done",
    });
    const todo = (step, detail) => ({
        step,
        state: "todo",
        detail,
    });
    const results = [];
    results.push(blank(state.originalTitle)
        ? todo("identity", "The title needs a name.")
        : blank(state.externalId)
            ? todo("identity", "The title needs a distributor id.")
            : done("identity"));
    const container = state.type ? isContainerType(state.type) : false;
    results.push(container
        ? { step: "master", state: "skipped" }
        : state.masterUploaded
            ? done("master")
            : todo("master", "No video file has finished uploading yet."));
    results.push(container
        ? { step: "subtitles", state: "skipped" }
        : state.subtitlesDecided
            ? done("subtitles")
            : todo("subtitles", "Add subtitle files, or say this title has none. Subtitles cannot be added after delivery."));
    results.push(texts.some(textIsComplete)
        ? done("description")
        : todo("description", "One language needs a title and all three synopsis lengths."));
    results.push(((_b = state.imageCount) !== null && _b !== void 0 ? _b : 0) > 0
        ? done("artwork")
        : todo("artwork", "The title has no artwork."));
    results.push(((_c = state.rightsCount) !== null && _c !== void 0 ? _c : 0) > 0
        ? done("rights")
        : todo("rights", "No licence window. A title with none is available everywhere, forever."));
    results.push(state.surface === "owner"
        ? { step: "packages", state: "skipped" }
        : ((_d = state.packageCount) !== null && _d !== void 0 ? _d : 0) > 0
            ? done("packages")
            : todo("packages", "The title is in no package, so it would play for nobody."));
    return results;
}
export function wizardMissing(state) {
    return wizardSteps(state)
        .filter((entry) => entry.state === "todo")
        .map((entry) => entry.step);
}
export const VOD_WIZARD_LABELS = {
    identity: "title details",
    master: "video file",
    subtitles: "subtitles",
    description: "description",
    artwork: "artwork",
    rights: "licence window",
    packages: "packages",
};
export function vodStepLabels(steps) {
    return steps.map((step) => { var _a; return (_a = VOD_WIZARD_LABELS[step]) !== null && _a !== void 0 ? _a : step; });
}
